export default "__VITE_ASSET__CKXio5Up__"